import type { Range } from "react-calendar/dist/esm/shared/types.js";
import type { CalendarDate, LooseCalendarDate } from "../BaseCalendar";

export function isDateRange(
  calendarDate: CalendarDate,
): calendarDate is Range<Date | null> {
  return Array.isArray(calendarDate);
}

export function isDateRangeWithDates(
  calendarDate: CalendarDate,
): calendarDate is [Date, Date] {
  return (
    Array.isArray(calendarDate) &&
    calendarDate[0] instanceof Date &&
    calendarDate[1] instanceof Date
  );
}

export function isLooseDateRange(
  calendarDate?: LooseCalendarDate,
): calendarDate is Range<Date | string | null> {
  return (
    Array.isArray(calendarDate) &&
    (calendarDate[0] instanceof Date ||
      typeof calendarDate[0] === "string" ||
      calendarDate[0] === null) &&
    (calendarDate[1] instanceof Date ||
      typeof calendarDate[1] === "string" ||
      calendarDate[1] === null)
  );
}
